
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCustomerCarPolicy } from '../../client/vendor_contract_client';

@Component
export default class CarPolicyInfo extends Vue {
    @Prop(String) readonly registrationNumber!: string;

    local = {
        loading: false,
        carPolicyLink: '',
        customerName: '',
    };

    async mounted() {
        this.local.loading = true;
        const customerCarPolicy = await getCustomerCarPolicy(this.registrationNumber);
        this.local.carPolicyLink = customerCarPolicy.policy;
        this.local.customerName = customerCarPolicy.customerName;
        this.local.loading = false;
    }

    goToCarPolicy() {
        window.open(this.local.carPolicyLink, '_blank');
    }
}
